import gql from "graphql-tag";

export const GET_PLANNING = gql`
  query getPlanning($startDate: String!, $endDate: String!) {
    planning(startDate: $startDate, endDate: $endDate) {
      users {
        id
        firstName
        lastName
        avatarUrl
        workDayHours
        email
        region
      }
      projects {
        id
        name
        color
        plannedTimeTracking
      }
      plannedTimes {
        id
        periodAndRecurrenceId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        tentative
        notes
        user {
          id
          firstName
          lastName
        }
        project {
          id
          name
          color
        }
        projectRole {
          id
          name
        }
        commercialStatusByDate {
          date
          status
          totalAmount
          securedAmount
          committedAmount
          pendingAmount
          uncoveredAmount
          tooltip
          trackingMode
        }
      }
      timeOffs {
        id
        periodAndRecurrenceId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        type
        user {
          id
          firstName
          lastName
        }
      }
      holidays {
        id
        date
        name
      }
      userHolidaysMap {
        userId
        holidays {
          id
          date
          name
        }
      }
      timesheetEntries {
        id
        date
        duration
        notes
        user {
          id
          firstName
          lastName
        }
        project {
          id
          name
          color
        }
        theme {
          id
          name
        }
        projectRole {
          id
          name
        }
      }
    }
  }
`;

export const GET_PLANNING_KPI_FOR_PERIOD = gql`
  query getPlanningKpiForPeriod(
    $startDate: String!
    $endDate: String!
    $userId: ID
  ) {
    planningKpiForPeriod(
      startDate: $startDate
      endDate: $endDate
      userId: $userId
    ) {
      loggedMinutes
      expectedMinutes
    }
  }
`;

export const GET_PLANNED_TIME_FOR_EDIT = gql`
  query getPlannedTimeForEdit($occurrenceId: ID!) {
    plannedTimeForEdit(occurrenceId: $occurrenceId) {
      occurrence {
        id
        periodAndRecurrenceId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        tentative
        notes
        user {
          id
          firstName
          lastName
        }
        project {
          id
          name
          color
        }
        projectRole {
          id
          name
        }
      }
      parent {
        id
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        tentative
        notes
      }
    }
  }
`;

export const GET_TIME_OFF_FOR_EDIT = gql`
  query getTimeOffForEdit($occurrenceId: ID!) {
    timeOffForEdit(occurrenceId: $occurrenceId) {
      occurrence {
        id
        periodAndRecurrenceId
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        type
        user {
          id
          firstName
          lastName
        }
      }
      parent {
        id
        startDate
        endDate
        frequency
        repeatEndDate
        durationPerDay
        type
      }
    }
  }
`;

export const GET_PLANNED_MAN_DAYS_FOR_SPRINTS = gql`
  query GetPlannedManDaysForSprints(
    $sprints: [SprintPlanningInput!]!
    $userIds: [ID!]
  ) {
    plannedManDaysForSprints(sprints: $sprints, userIds: $userIds) {
      projectId
      startDate
      endDate
      plannedManDays
      remainingPlannedManDays
      userIds
      users {
        userId
        fullName
        plannedManDays
      }
    }
  }
`;
